import type { TFunction } from "i18next"

/**
 * Traduz os status de transação/refund/atualização (ex.: AUTHORIZED, PAID,
 * CANCELLED) que o backend envia como enum cru.
 *
 * Módulo puro (sem React) — o `t` é injetado para permitir teste isolado do
 * resolvedor de chave.
 */

// Mapa status (case-insensitive) → labelKey em `orders.transactionsTable.statuses`.
// Cobre as duas grafias de cancelamento (CANCELED/CANCELLED) que aparecem no
// backend (transação usa uma, refund usa a outra).
const TRANSACTION_STATUS_LABEL_KEYS: Record<
  string,
  string
> = {
  AUTHORIZED: "authorized",
  CAPTURED: "captured",
  PAID: "paid",
  PENDING: "pending",
  PROCESSING: "processing",
  REFUNDED: "refunded",
  CANCELED: "canceled",
  CANCELLED: "canceled",
  FAILED: "failed",
  COMPLETED: "completed",
  SUCCESS: "success",
  REVERSED: "reversed",
  EXPIRED: "expired",
}

/**
 * Resolve o labelKey i18n de um status de transação. Retorna `null` para
 * status desconhecido ou vazio (o chamador decide o fallback).
 */
export const resolveTransactionStatusLabelKey = (
  status?: string
): string | null => {
  if (!status) return null
  return (
    TRANSACTION_STATUS_LABEL_KEYS[status.toUpperCase()] ??
    null
  )
}

/**
 * Retorna o rótulo traduzido do status. Para status desconhecido, devolve o
 * valor original (não perde informação) ou "-" quando vazio.
 */
export const getTransactionStatusLabel = (
  status: string | undefined,
  t: TFunction
): string => {
  const key = resolveTransactionStatusLabelKey(status)
  if (!key) return status ?? "-"
  return t(`orders.transactionsTable.statuses.${key}`)
}
